import React from "react";
import { StyleSheet, View } from "react-native";
import { THEME_COLORS } from "../../../common/styles";
import shallowEqual from "react-apollo/utils/shallowEqual";

interface IRowComponentProps {
  row: any;
  renderColumn: any;
}

const RowComponent = (props: IRowComponentProps) => {
  const row = props.row;
  const renderColumn = props.renderColumn;
  return (
    <View
      style={[
        {
          flexDirection: "row",
          flex: 1,
          borderBottomColor: "rgb(240,240,240)",
          alignItems: "center",
          borderBottomWidth: 1.5,
          paddingVertical: 10,
          justifyContent: "center",
        },
      ]}
    >
      {row.map((column, columnIndex) => {
        return (
          <View
            key={columnIndex}
            style={[styles.rowHeaderColumn, column.style, {marginRight:20}]}
          >
            {renderColumn(column)}
          </View>
        );
      })}
    </View>
  );
};
const getCompareObject = (props: IRowComponentProps) => {
  const a = props.row.reduce(function (finalObject, obj, index) {
    const d = { ...finalObject, [`value${index}`]: obj.value };
    return d;
  }, {});
  return a;
};
const areEqual = (
  nextProps: IRowComponentProps,
  prevProps: IRowComponentProps
) => {
  // const a = shallowEqual(getCompareObject(nextProps), getCompareObject(prevProps));
  return (
    JSON.stringify(getCompareObject(nextProps)) ===
    JSON.stringify(getCompareObject(prevProps))
  );
};

export default React.memo(RowComponent, areEqual);

const styles = StyleSheet.create({
  rowHeaderColumn: {
    flex: 1,
    paddingLeft: 10,
    paddingVertical: 8,
    paddingRight: 2,
    height: "100%",
  },
});
